import React from "react";

const LoginFormRegister = () => {
  return (
    <div className="login__form--register">
      <p>Другой метод входа</p>
      <button>Зарегистрироваться</button>
    </div>
  );
};

export default LoginFormRegister;
